
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/link-demo/payment_initiation",
      function () {
        return require("private-next-pages/link-demo/payment_initiation.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/link-demo/payment_initiation"])
      });
    }
  